import { Service } from './mainService'

const suspensaoAdvogadoService = {
    listarSuspensoes,
    cadastrarSuspensao,
    editarSuspensao,
    excluirSuspensao,
    buscarSuspensao,
    buscarAdvogadoPorCpf,
    existeSuspensaoVigente
}

async function listarSuspensoes() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_USERS_API + "/suspensaoadvogado/listar");
        return response;
    } catch (e) {
        return e.response;
    }
}

async function cadastrarSuspensao(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_USERS_API + "/suspensaoadvogado/cadastrar", data);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function editarSuspensao(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_USERS_API + "/suspensaoadvogado/editar/"+data.id, data);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function excluirSuspensao(idSuspensao) {
    try {
        const response = await Service.$http.delete(process.env.VUE_APP_USERS_API + "/suspensaoadvogado/excluir/"+idSuspensao);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function buscarSuspensao(idSuspensao) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_USERS_API + "/suspensaoadvogado/buscar/"+idSuspensao);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function buscarAdvogadoPorCpf(cpfAdvogado) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_USERS_API + "/suspensaoadvogado/buscarAdvogado/"+cpfAdvogado);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function existeSuspensaoVigente() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_USERS_API + "/suspensaoadvogado/existeSuspensaoVigente/");
        return response;
    } catch (e) {
        return e.response;
    }
}

export default suspensaoAdvogadoService;